import { render } from "./TransportTab.vue?vue&type=template&id=657940c5"
import script from "./TransportTab.vue?vue&type=script&lang=js"
export * from "./TransportTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__